import React from 'react';
import {connect} from 'react-redux';
import BaseMultConsumption from 'components/BaseMultConsumption';
import {getConsumptionByApp} from 'actions/consumption';
import {getChartSeries} from 'utils/consumptionTool';

const SKULIST = [
    {
        name:'Face verification',
        contract_type:5,
        columns:[
            {
                title: 'Time',
                dataIndex: 'day',
                key: 'day',
                sorter:true
            },{
                title: 'SDK Face verification',
                dataIndex: 'a_verify',
                key: 'a_verify',
                sorter:true
            },{
                title: 'H5 Face verification',
                dataIndex: 'a_mobile',
                key: 'a_mobile',
                sorter:true
            }
        ],
        subTitleRender:(data)=>{
            const total = data.total || {};
            return <p>(Face verification: <span style={{color:'#6D74F4'}}>{total['a_verify']||0}</span>)</p>;
        },
        chartSeries:getChartSeries([
            {
                key:'a_verify',
                name:'SDK Face verification',
                color:'#8A90FF'
            },
            {
                key:'a_mobile',
                name:'h5 Face verification',
                color:'#99CCFF'
            }
        ])
    },
    {
        name:'Face verification Advanced',
        contract_type:32,
        columns:[
            {
                title: 'Time',
                dataIndex: 'day',
                key: 'day',
                sorter:true
            },{
                title: 'SDK Face verification',
                dataIndex: 'av5_verify',
                key: 'av5_verify',
                sorter:true
            },{
                title: 'H5 Face verification',
                dataIndex: 'av5_mobile',
                key: 'av5_mobile',
                sorter:true
            }
        ],
        subTitleRender:(data)=>{
            const total = data.total || {};
            return <p>(Face verification: <span style={{color:'#6D74F4'}}>{total['av5_verify']||0}</span>)</p>;
        },
        chartSeries:getChartSeries([
            {
                key:'av5_verify',
                name:'SDK Face verification',
                color:'#8A90FF'
            },
            {
                key:'av5_mobile',
                name:'h5 Face verification',
                color:'#99CCFF'
            }
        ])
    },
    {
        name:'Face Search',
        contract_type:55,
        columns:[
            {
                title: 'Time',
                dataIndex: 'day',
                key: 'day',
                sorter:true
            },{
                title: 'Face Search',
                dataIndex: 'face_search_count',
                key: 'face_search_count',
                sorter:true
            },{
                title: 'Face Add',
                dataIndex: 'face_add_count',
                key: 'face_add_count',
                sorter:true
            }
        ],
        subTitleRender:(data)=>{
            const total = data.total || {};
            return <p>(Face Search: <span style={{color:'#6D74F4',marginRight:'10px'}}>{total['face_search_count']||0}</span>Face Add: <span style={{color:'#6D74F4'}}>{total['face_add_count']||0}</span>)</p>;
        },
        chartSeries:getChartSeries([
            {
                key:'face_search_count',
                name:'Face Search',
                color:'#8A90FF'
            },
            {
                key:'face_add_count',
                name:'Face Add',
                color:'#99CCFF'
            }
        ])
    }
];


class KTPConsumption extends React.Component {

    constructor(props){
        super(props);
        this.skuHashMap = {};
        this.skuList = SKULIST.map(item=>{
            this.skuHashMap[item.contract_type] = item;
            const {name,contract_type} = item;
            return {name,contract_type};
        });
    }

    render() {
        return (
            <BaseMultConsumption
                skuList={SKULIST}
                chartSeries={this.chartSeries}
                getInfoPromise={getConsumptionByApp}
            />
        );

    }

}


function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(KTPConsumption);



// WEBPACK FOOTER //
// ./src/pages/Consumption/index.js